import { render } from "./ViewNotFound.vue?vue&type=template&id=0ad96b76&scoped=true"
import script from "./ViewNotFound.vue?vue&type=script&lang=js"
export * from "./ViewNotFound.vue?vue&type=script&lang=js"

import "./ViewNotFound.vue?vue&type=style&index=0&id=0ad96b76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad96b76"]])

export default __exports__